import { GetMaskingService } from './../../../adapters/getMasking.service';
import { Component, OnInit, ViewChild, Injector, signal, model, ChangeDetectionStrategy } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from 'src/app/shared/service/modal/modal.service';
import { LineModalTemplateService } from 'src/app/shared/service/modal/components/line-modal-template/line-modal-template.service';
import { FormVerifyCustomerService } from '../services/form-verify-customer.service';
import { ConcentService } from '../services/concent.service';
import { FormRegistrationService } from '../services/form-registration.service';
import { LoaderService } from '../services/loader.service';
import { LineStateActionService } from '../statemanagement/line-state-action.service';
import { SetIdentityAction } from '../statemanagement/action/identity.action';
import { Customer, Identity } from '../models/customer.model';
import { SetCustomerAction } from '../statemanagement/action/customer.action';
import { LoggerService } from "../services/logger.service"
import { TermsAndConditionService } from '../services/terms-and-condition.service';
import { encryptData } from 'src/app/core/utilities';
import { ResponseCodeRegistration } from '../models/registration.model';
import { LineNotificationService } from '../services/line-notification.service';
import { ClaimService } from '../services/claim.service';
import { Observable } from 'rxjs';
import { BaseComponents } from '../../../base.component';
import { ResponseStatusLine } from '../models/termAndConditionLine.model';
import { ResponseStatus } from '../models/termAndCondition.model';
import { ReferenceService } from 'src/app/services/reference.service';
@Component({
    selector: 'app-form-readonly',
    templateUrl: './form-readonly.component.html',
    styleUrls: ['./form-readonly.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class FormReadonlyComponent extends BaseComponents implements OnInit {

  model = model<any>({
    form: {
      idcard: { value: '', text: '' }, //0-00XX-XXXXX-00-0
      mobile: { value: '', text: '' }, //00X-XXX-X000     
    }
  });
  remarkText = signal<string>('');
  remarksGroup: {} = {
    "insure": `หมายเหตุ : <br>
      1.การสมัครใช้บริการครั้งนี้เพื่อให้ท่านสามารถรับบริการหลังการขายผ่านช่องทางไลน์ TISCO Insure ได้สะดวกยิ่งขึ้น <br>
      2. เพื่อยกระดับการให้บริการประกันภัย ท่านจะได้รับบริการแจ้งเตือนต่างๆผ่านช่องทางไลน์ TISCO Insure ตามเบอร์โทรศัพท์มือถือที่ท่านได้ลงทะเบียนไว้`,
    "mazda": `หมายเหตุ : <br>
      1.การสมัครใช้บริการครั้งนี้เพื่อให้ท่านสามารถรับบริการหลังการขายผ่านช่องทางไลน์ Mazda MPI ได้สะดวกยิ่งขึ้น <br>
      2.เพื่อยกระดับการให้บริการประกันภัย ท่านจะได้รับบริการแจ้งเตือนต่างๆผ่านช่องทางไลน์ Mazda MPI ตามเบอร์โทรศัพท์มือถือที่ท่านได้ลงทะเบียนไว้`,
    "ford": `หมายเหตุ : <br>
      1.การสมัครใช้บริการครั้งนี้เพื่อให้ท่านสามารถรับบริการหลังการขายผ่านช่องทางไลน์ Ford Ensure ได้สะดวกยิ่งขึ้น <br>
      2.เพื่อยกระดับการให้บริการประกันภัย ท่านจะได้รับบริการแจ้งเตือนต่างๆผ่านช่องทางไลน์ Ford Ensure ตามเบอร์โทรศัพท์มือถือที่ท่านได้ลงทะเบียนไว้`,
    "nissan": `หมายเหตุ : <br>
      1.การสมัครใช้บริการครั้งนี้เพื่อให้ท่านสามารถรับบริการหลังการขายผ่านช่องทางไลน์ Nissan Insure ได้สะดวกยิ่งขึ้น <br>
      2.เพื่อยกระดับการให้บริการประกันภัย ท่านจะได้รับบริการแจ้งเตือนต่างๆผ่านช่องทางไลน์ Nissan Insure ตามเบอร์โทรศัพท์มือถือที่ท่านได้ลงทะเบียนไว้`,
    "gwm": `หมายเหตุ : <br>
      1.การสมัครใช้บริการครั้งนี้เพื่อให้ท่านสามารถรับบริการหลังการขายผ่านช่องทางไลน์ GWM Smart Drive ได้สะดวกยิ่งขึ้น <br>
      2.เพื่อยกระดับการให้บริการประกันภัย ท่านจะได้รับบริการแจ้งเตือนต่างๆผ่านช่องทางไลน์ GWM Smart Drive ตามเบอร์โทรศัพท์มือถือที่ท่านได้ลงทะเบียนไว้`
  }
  // 5 = SMS, 6=QR, 8=LON
  btnSubmitGroup: {} = {
    5: "ยืนยันและเพิ่มเพื่อน",
    6: "ถัดไป",
    8: "ยืนยันและเพิ่มเพื่อน"
  }
  btnSubmitText = signal<string>("ถัดไป");
  ref: string = "";
  liff_motor: string = "";
  flow: number;
    bg_image = "/assets/images/bg-form/#brand#-bg-verify-form-m.png";
  classify_insure: number;
  log_session_text: string = "form-readonly";
  referenceUUID: string | null = null;
  constructor(
    protected injectorObj: Injector,
    private router: Router,
    private route: ActivatedRoute,
    private verifyCustomerService: FormVerifyCustomerService,
    private concentService: ConcentService,
    private formRegistrationService: FormRegistrationService,
    private loaderService: LoaderService,
    private lineStateAction: LineStateActionService,
    private lineActionService: LineStateActionService,
    private loggerService: LoggerService,
    private getMaskingService : GetMaskingService,
    private termsAndConditionService: TermsAndConditionService,
    private lineNotificationService: LineNotificationService,
    private claimService:ClaimService,
    private referenceService:ReferenceService
  ) { 
    super(injectorObj);
  }

  ngOnInit() {
    const funcName = "ngOnInit";
    this.log_session_text = `form-readonly referenceUUID:[${this.referenceService.getReferenceUUID()}]`;
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const channel = this.lineStateAction.channelStateInfo;
    this.logger.info(`${this.log_session_text} ${funcName} channel:${JSON.stringify(channel)}`);
    this.bg_image = this.bg_image.replace("#brand#", channel.comCode);
    const identity_preset = this.lineStateAction.identityStateInfo;  //test   
    console.log("identify preset", identity_preset) //test
    this.logger.info(`${this.log_session_text} ${funcName} identify preset ${identity_preset ? JSON.parse(JSON.stringify(identity_preset)) : null}`) //test]);
    if (channel && channel.refCode) {
      const log_refCode = this.getMaskingService.maskingData(channel.refCode);
      this.logger.info(`${this.log_session_text} ${funcName} channel refCode : ${log_refCode}`);
      const requestBody = {
        "lead_reference_number": channel.refCode
      }
      this.route.queryParams.subscribe(async (params) => {
        this.ref = params.ref
        this.liff_motor = params.liff_motor
        this.flow = params.flow
        this.classify_insure = params.classify_insure
        this.logger.info(`${this.log_session_text} ${funcName} ref:${this.ref} liff_motor:${this.liff_motor} flow:${this.flow} classify_insure:${this.classify_insure}`);
      });
      this.verifyCustomerService.apiGetLeadCustomerRegistration(requestBody).subscribe((result) => {
        if (result && result.data) {
          let showlogresult = {
            first_name:this.getMaskingService.maskingData(result.data['first_name']),
            id_card:this.getMaskingService.maskingData(result.data['id_card']),
            last_name:this.getMaskingService.maskingData(result.data['last_name']),
            phone_number:this.getMaskingService.maskingData(result.data['phone_number']),
            third_party:result.data['third_party'],
            ucid:result.data['ucid']
          }
          this.logger.info(`${this.log_session_text} apiGetLeadCustomerRegistration ${JSON.stringify(showlogresult)}`);
          const identity = {
            "id_card": result.data["id_card"],
            "phone_number": result.data["phone_number"],
            "update_chanel_identity_flag": identity_preset ? identity_preset.update_chanel_identity_flag : false,
          } as Identity;
          const showlogidentity = {
            "id_card": this.getMaskingService.maskingData(result.data["id_card"]),
            "phone_number": this.getMaskingService.maskingData(result.data["phone_number"]),
            "update_chanel_identity_flag": identity_preset ? identity_preset.update_chanel_identity_flag : false,
          } as Identity;
          this.logger.info(`${this.log_session_text} apiGetLeadCustomerRegistration identity: ${JSON.stringify(showlogidentity)}`);
          this.lineActionService.sinkIdentity.next(new SetIdentityAction(identity))
          const customer = {
            "firstname": result.data["first_name"],
            "lastname": result.data["last_name"],
          } as Customer       
          const log_customer = {
            firstname : this.getMaskingService.maskingData(result.data["first_name"]),
            lastname : this.getMaskingService.maskingData(result.data["last_name"])
          }
          this.logger.info(`${this.log_session_text} apiGetLeadCustomerRegistration customer: ${JSON.stringify(log_customer)}`);
          this.lineActionService.sinkCustomer.next(new SetCustomerAction(customer))
          this.feedData(identity)
          channel.oaMessageUrl = 'https://line.me/R/oaMessage/' + channel.lineBotId + '/RG_'
          const resultThirdParty = result.data["third_party"]
          if (resultThirdParty) {
            this.logger.info(`${this.log_session_text} ${funcName} resultThirdParty: ${JSON.stringify(resultThirdParty)}`);
            // https://line.me/R/oaMessage/@165yoshn/mazda
            channel.oaMessageUrl += resultThirdParty.join(',');
            console.log('oaMessage is:', channel.oaMessageUrl);
            this.logger.info(`${this.log_session_text} oaMessage is: ${channel.oaMessageUrl}`);
          }
          if(channel.registerFlow == "renew"){
            channel.oaMessageUrl = 'https://line.me/R/oaMessage/'+channel.lineBotId
          }else if(channel.registerFlow == "claim"){
            channel.oaMessageUrl = 'https://line.me/R/oaMessage/'+channel.lineBotId
          }

          Observable.forkJoin(this.lineActionService.observableChannel, this.lineActionService.observableIdentity, this.lineActionService.observableCustomer)
        } else {
          this.logger.info(`${this.log_session_text} apiGetLeadCustomerRegistration not result goto page completed`);
          this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'notfound', substatus: 'short', code: 'E00005' } });
        }
      })
    }
    this.setButton(channel.subChannel);
    this.setRemark(channel.comCode);
  }

  feedData(identity) {
    if (identity) {
      const current = structuredClone(this.model());
      current.form.idcard.value = identity.id_card;
      current.form.mobile.value = identity.phone_number;
      if (current.form.idcard.value && current.form.idcard.value.length == 13) {
        current.form.idcard.text = current.form.idcard.value.substr(0, 3) + "X".repeat(7) + current.form.idcard.value.substr(10, 3);
      }
      if (current.form.mobile.value && current.form.mobile.value.length == 10) {
        current.form.mobile.text = current.form.mobile.value.substr(0, 2) + "X".repeat(5) + current.form.mobile.value.substr(7, 3);
      }

      this.model.set(current);
    }
  }

  setButton(subchannel) {
    if (subchannel) {
      this.btnSubmitText.set(this.btnSubmitGroup[subchannel])
    }
  }

  setRemark(comcode) {
    if (comcode) {
      this.remarkText.set(this.remarksGroup[comcode]);
    }
  }

  onSubmit() {
    const funcName = "onSubmit";
    const channel = this.lineStateAction.channelStateInfo;
    const customer = this.lineStateAction.customerStateInfo;
    const identity = this.lineStateAction.identityStateInfo;
    if (channel.subChannel == "5") {
      //case sms
      console.log("case add friend SMS 5");
      this.logger.info(`${this.log_session_text} ${funcName} case add friend SMS 5`);
      this.loaderService.opendLoader();
      this.register();
    } else if (channel.subChannel == "6") {
      console.log("case OTP QR 6");
      this.logger.info(`${this.log_session_text} ${funcName} case OTP QR 6`);
      const data = {
        ...customer,
        ...identity,
        ...channel,
        more: {
          update_channel_identity_flag: identity.update_chanel_identity_flag,
        },
        update_channel_identity_flag: identity.update_chanel_identity_flag,
      };
      this.logger.info(`${this.log_session_text} ${funcName} redirectConfirmOTP start`);
      this.redirectConfirmOTP(data);
      this.logger.info(`${this.log_session_text} ${funcName} redirectConfirmOTP end`);
    } else if (channel.subChannel == "8") {
      this.logger.info(`${this.log_session_text} ${funcName} case add friend LINE LON 8`);
      this.loaderService.opendLoader();
      this.register();
    }
  }

  async callTermAndCondition(identityUcid) {
    const funcName = "callTermAndCondition";
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const channel = this.lineStateAction.channelStateInfo;
    const customer = this.lineStateAction.customerStateInfo;
    const identity = this.lineStateAction.identityStateInfo;
    let body = {
      "comcode": channel.comCode,
      // "channel_identity": channel.channel_identity,
      "electronic_channel": channel.electronic_channel,
      "application_channel_reference": channel.application_channel_reference,
      "app_no": channel.appNo as number,
      "term_and_condition_id": (channel.termsAndCondition ? channel.termsAndCondition.termConditionId : null),
      "first_name": customer.firstname,
      "last_name": customer.lastname,
      "id_no": identity.id_card,
      "identity_ucid": identityUcid
    }   
    let showlogbody = {
      "comcode": channel.comCode,
      // "channel_identity": channel.channel_identity,
      "electronic_channel": channel.electronic_channel,
      "application_channel_reference": channel.application_channel_reference,
      "app_no": channel.appNo as number,
      "term_and_condition_id": (channel.termsAndCondition ? channel.termsAndCondition.termConditionId : null),
      "first_name": this.getMaskingService.maskingData(customer.firstname),
      "last_name": this.getMaskingService.maskingData(customer.lastname),
      "id_no": this.getMaskingService.maskingData(identity.id_card),
      "identity_ucid": identityUcid
    }
    this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition body:${JSON.stringify(showlogbody)}`)
    this.termsAndConditionService.apiCreateOrUpdateTermsAndCondition(body).subscribe(result => {
      this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition response_code:${result?.response_code}`)
      if (result && result.response_code == "40000") {
        console.log(["create or update success: ", result]);
        this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition create or update success:${JSON.stringify(result)}`)

        channel.termsAndCondition.status = ResponseStatus.COMPLETED;
        this.lineStateAction.observableChannel.subscribe();
        //this.callConcent();
      } else {
        this.logger.info(`${this.log_session_text} ${funcName} apiCreateOrUpdateTermsAndCondition create or update fail goto page completed status fail`);
        this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00002' } });
      }
    })
  }

  async callTermAndConditionLine(identityUcid) {
    const customer = this.lineStateAction.customerStateInfo;
    const identity = this.lineStateAction.identityStateInfo;
    const channel = this.lineStateAction.channelStateInfo; 
    let body = {
        "identity_ucid": identityUcid,
        "comcode": channel.comCode,
        "id_no": identity.id_card,
        "first_name": customer.firstname,
        "last_name": customer.lastname,
        // "channel_identity": channel.channel_identity,
        "electronic_channel": channel.electronic_channel,
        "application_channel_reference": channel.application_channel_reference,
        "app_no": channel.appNo,
        "term_and_condition_id": (channel.termsAndConditionLine ? channel.termsAndConditionLine.termConditionId : null)
    }
    let showlogbody = {
      "identity_ucid": identityUcid,
      "comcode": channel.comCode,
      "id_no": this.getMaskingService.maskingData(identity.id_card),
      "first_name": this.getMaskingService.maskingData(customer.firstname),
      "last_name": this.getMaskingService.maskingData(customer.lastname),
      // "channel_identity": channel.channel_identity,
      "electronic_channel": channel.electronic_channel,
      "application_channel_reference": channel.application_channel_reference,
      "app_no": channel.appNo,
      "term_and_condition_id": (channel.termsAndConditionLine ? channel.termsAndConditionLine.termConditionId : null)  
    }
    this.logger.info(`${this.log_session_text} apiCreateOrUpdateTermsAndCondition line body:${showlogbody}`)
    this.termsAndConditionService.apiCreateOrUpdateTermsAndCondition(body).subscribe(result => {
    this.logger.info(`${this.log_session_text} apiCreateOrUpdateTermsAndCondition line body:${showlogbody}`)
        if (result && result.response_code == "40000") {
            console.log(["create_or_update_success_line: ", result]);
            channel.termsAndConditionLine.status = ResponseStatusLine.COMPLETED;
            this.lineStateAction.observableChannel.subscribe();
            // this.callConcent();
        } else {
            this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00004' } });
        }
    })
}

  private redirectConfirmOTP(param = null) {
    const funcName = "redirectConfirmOTP";
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const current = this.model()
    const params = {
      idcard: current.form.idcard.value,
      mobile: current.form.mobile.value,
      // lineId: this.model.form.lineId.value,
      more: param
    }
    const log_params = {
      idcard: this.getMaskingService.maskingData(current.form.idcard.value),
      mobile: this.getMaskingService.maskingData(current.form.mobile.value),
      // lineId: this.model.form.lineId.value,
      more: param
    }
    this.logger.info(`${this.log_session_text} ${funcName} params: ${JSON.stringify(log_params)} goto page confirm-otp`);
    const query = encryptData(this.b64EncodeUnicode(JSON.stringify(params)));
    this.router.navigate(['../confirm-otp'], { relativeTo: this.route, queryParams: { params: query, ref: this.ref, liff_motor: this.liff_motor, flow: this.flow, classify_insure: this.classify_insure } });
  }

  b64EncodeUnicode(str) {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16))
    }))
  }

  register() {
    const funcName = 'register';
    const customer = this.lineStateAction.customerStateInfo;
    const identity = this.lineStateAction.identityStateInfo;
    const channel = this.lineStateAction.channelStateInfo;
    const payload: any = {
      ...customer,
      ...identity,
      ...channel,
      update_channel_identity_flag: identity.update_chanel_identity_flag
    };
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    this.logger.info(`${this.log_session_text} ${funcName} channel:${JSON.stringify(channel)}`);
    let showlogpayload: any = {
      accident_no:payload.accident_no,
      appNo:payload.appNo,
      application_channel_reference:payload.application_channel_reference,
      branded:payload.branded,
      channel_identity:payload.channel_identity,
      comCode:payload.comCode,
      electronic_channel:payload.electronic_channel,
      firstname:this.getMaskingService.maskingData(payload.firstname),
      friendshipFlag:payload.friendshipFlag,
      id_card:this.getMaskingService.maskingData(payload.id_card),
      identityId:payload.identityId,
      lastname:this.getMaskingService.maskingData(payload.lastname),
      liffId:payload.liffId,
      liffUrl:payload.liffUrl,
      lineBotId:payload.lineBotId,
      oaMessageUrl:payload.oaMessageUrl,
      octp_channel_id:payload.octp_channel_id,
      phone_number:this.getMaskingService.maskingData(payload.phone_number),
      refCode:payload.refCode,
      registerFlow:payload.registerFlow,
      registerType:payload.registerType,
      rm_channel_id:payload.rm_channel_id,
      subChannel:payload.subChannel,
      subflow:payload.subflow,
      termsAndCondition:payload.termsAndCondition,
      termsAndConditionLine:payload.termsAndConditionLine,
      update_chanel_identity_flag:payload.update_chanel_identity_flag,
      update_channel_identity_flag:payload.update_channel_identity_flag,
      verify_identity_token:payload.verify_identity_token,
    }
    this.logger.info(`${this.log_session_text} ${funcName} apiRegisteration payload:${showlogpayload}`);
    this.formRegistrationService.apiRegistration(payload).subscribe(async (result) => {
        this.loaderService.closeLoader();
        this.logger.info(`${this.log_session_text} ${funcName} apiRegisteration found data: ${JSON.stringify(result)}`)
        if (!result) {
          this.logger.info(`${this.log_session_text} ${funcName} apiRegisteration result not have value goto page completed status fail`);
          this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: 'E00000' } });
        }
        // const json_res = JSON.stringify(result);
        // console.log(json_res);
        this.logger.info(`${this.log_session_text} ${funcName} apiRegisteration result state_code:${result.state_code}`)
        switch (result.state_code) {
          case ResponseCodeRegistration.SUCCESS: {
            const channel = this.lineStateAction.channelStateInfo;
            this.logger.info(`${this.log_session_text} ${funcName} apiRegisteration flow", ${channel?.registerFlow}`);
            if(channel.registerFlow == "claim"){
              this.logger.info(`${this.log_session_text} ${funcName} registerClaimAppointment start`);
              this.registerClaimAppointment(channel.refCode,result["_1"],channel.electronic_channel,channel.rm_channel_id,channel.liffId);
              this.logger.info(`${this.log_session_text} ${funcName} registerClaimAppointment end`);
            }
            this.logger.info(`${this.log_session_text} ${funcName} channel.termsAndCondition.action: ${channel?.termsAndCondition?.action}`);
            if (channel && channel.termsAndCondition && channel.termsAndCondition.action == "accept") {
              //branded
              this.logger.info(`${this.log_session_text} ${funcName} termsAndCondition accept callTermAndCondition start`);
              await this.callTermAndCondition(result["_1"]);
              this.logger.info(`${this.log_session_text} ${funcName} termsAndCondition accept callTermAndConditionLine start`);
              await this.callTermAndConditionLine(result["_1"]);
              this.logger.info(`${this.log_session_text} ${funcName} termsAndCondition accept callConsent start`);
              this.callConcent();

          }  else {
                //tiscoinsure
                this.logger.info(`${this.log_session_text} ${funcName} case termsAndCondition not accept channel.termsAndConditionLine.action: ${channel?.termsAndConditionLine?.action}`);
                if (channel && channel.termsAndConditionLine && channel.termsAndConditionLine.action == "accept") {
                  this.logger.info(`${this.log_session_text} ${funcName} case termsAndConditionLine accept callTermAndConditionLine start`);
                  await  this.callTermAndConditionLine(result["_1"]);
              }
                this.logger.info(`${this.log_session_text} ${funcName} case termsAndCondition not accept callConcent start`);
              this.callConcent();
            }
            break;
          }
          default: {
            this.logger.info(`${this.log_session_text} ${funcName} apiRegisteration redirect complete status fail`);
            this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'fail', code: result.state_code } });
          }
        }
      })
  }

  registerClaimAppointment(refCode,customerId,electronicChannel,rm_channel_id,line_liff_register){    
    this.claimService.apiRegisterClaim({ref_code:refCode,customer_id:customerId,electronic_channel:electronicChannel,rm_channel_id:rm_channel_id,line_liff_register:line_liff_register}).subscribe(
      res=>{
        this.logger.info(`${this.log_session_text} registerClaimAppointment res: ${JSON.stringify(res)}`);
        console.log(res);
    })
  }


  async callConcent() {
    const funcName = "callConcent";
    this.logger.info(`${this.log_session_text} ${funcName} start`);
    const customer = this.lineStateAction.customerStateInfo;
    const identity = this.lineStateAction.identityStateInfo;
    const channel = this.lineStateAction.channelStateInfo;
    let liffUrl = channel.liffUrl;
    this.logger.info(`${this.log_session_text} ${funcName} liffUrl:${liffUrl}`);
    if (channel.registerFlow.toLowerCase() == "short") {
      this.logger.info(`${this.log_session_text} ${funcName} registerFlow == short`);
      liffUrl = channel.oaMessageUrl;
    } else {
      this.logger.info(`${this.log_session_text} ${funcName} sendNotification start`);
      let payload = {
        ...channel,
        "template_ref": "END_REGISTER",
        "template_parameter": {}
      }
      this.lineNotificationService.sendNotificationWithTemplate(payload).subscribe(
        (result_line: any) => {
          this.logger.info(`${this.log_session_text} ${funcName} sendNotification result: ${JSON.stringify(result_line)}`);
          console.log('notify result: ', result_line);
        }
      );
    }
    if (( (channel.registerFlow.toLowerCase() == "short" || channel.registerFlow == "renew" || channel.registerFlow == "claim") && channel.comCode == "insure") 
    || (channel.registerFlow.toLowerCase() != "short" && this.flow != 2)) {
      this.logger.info(`${this.log_session_text} ${funcName} registerFlow == short or renew or claim && comCode == insure || registerFlow != short && flow != 2`);
      let cust_type = 1;
      let body = {
        "comcode": channel.comCode,
        "cust_type": cust_type,
        "id_no": identity.id_card,
        "first_name": customer.firstname,
        "last_name": customer.lastname,
        "line_channel_id": channel.application_channel_reference,
        // "line_user_id": channel.channel_identity,
        "electronic_channel": channel.electronic_channel,
        "liff_id": liffUrl,
        "branded": channel.branded,
        "flow_name": channel.registerFlow
      }
      let showlog = {    
          "comcode": channel.comCode,
          "cust_type": cust_type,
          "id_no": this.getMaskingService.maskingData(identity.id_card),    
          "first_name": this.getMaskingService.maskingData(customer.firstname),
          "last_name": this.getMaskingService.maskingData(customer.lastname),     
          "line_channel_id": channel.application_channel_reference,
          // "line_user_id": channel.channel_identity,
          "electronic_channel": channel.electronic_channel,
          "liff_id": liffUrl,
          "branded": channel.branded,
          "flow_name": channel.registerFlow        
      }
      this.logger.info(`${this.log_session_text} callConcent apiConcentUrl body:${JSON.stringify(showlog)}`);

      this.concentService.apiConcentUrl(body).subscribe(result => {
        this.loaderService.closeLoader();        
        this.logger.info(`${this.log_session_text} callConcent apiConcentUrl response`);
        if (result && result.data && result.data.token_url) {
          this.logger.info(`${this.log_session_text} callConcent apiConcentUrl have token_url result.data.token_url:${result?.data?.token_url}`);
          if(channel.registerFlow == 'claim'){
            this.logger.info(`${this.log_session_text} callConcent apiConcentUrl have token_url registerflow == claim`);
            sessionStorage.setItem("consent","1");
          }          
          window.location.href = result.data.token_url;
        } else if (result && result.data) {
          this.logger.info(`${this.log_session_text} callConcent apiConcentUrl have result_data channel.registerFlow:${channel?.registerFlow}`)
          if(channel.registerFlow == 'claim'){
            this.logger.info(`${this.log_session_text} callConcent apiConcentUrl have result_data channel goto page completed status success`);
            this.router.navigate(['../completed'], { relativeTo: this.route, queryParams: { status: 'success' } });
          }else{
            this.logger.info(`${this.log_session_text} callConcent apiConcentUrl have result_data flow other`);
            window.location.href = liffUrl;
          }
          
        }
        this.logger.info(`${this.log_session_text} callConsent result`);
        console.log('consent result: ', result);
      });
    } else {
      this.loaderService.closeLoader();
      // console.log(liffUrl)
      this.logger.info(`${this.log_session_text} callConcent case not register flow url :${liffUrl}`);
      window.location.href = liffUrl;
    }


  }


  setSessionStorage(sessionRef) {
    const channel = this.lineActionService.channelStateInfo;
    const identity = this.lineStateAction.identityStateInfo;
    const customer = this.lineStateAction.customerStateInfo;
    let json = {
      "channel": channel,
      "identity": identity,
      "customer": customer
    }
    this.logger.info(`${this.log_session_text} set sessionStorage`)
    sessionStorage.setItem(sessionRef, JSON.stringify(json));
  }

}
